import { MyPageWrapper } from "./styled"
import SideBar from "./components/SideBar"
import { useLocation } from "react-router-dom"
import Profile from "./components/Profile"
import { useSelector } from "react-redux"
import { authSelector } from 'redux/selector'
import ChangePassword from "./components/ChangePassword"
import TourOrder from "./components/TourOrder"

const MyPage = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const qPage = query.get("page");
    const authState = useSelector(authSelector)
    return (
        <MyPageWrapper>
            <div className="grid wide">
                <div className="my-page_main row pt-15">
                    <div className="col l-3"><SideBar data={authState.currentUser.user} /></div>
                    <div className="col l-9">
                        {(!qPage || qPage === "me") && <Profile data={authState.currentUser.user} loading={authState.isFetching} />}
                        {
                            qPage === "change-password" && <ChangePassword />
                        }
                        {
                            qPage === "tour" && <TourOrder />
                        }
                    </div>
                </div>
            </div>
        </MyPageWrapper>
    )
}

export default MyPage